import { useTranslate } from '@va/localization';
import { GrayGradientDivider, ModalHeader } from '@va/ui/design-system';
import { ModalWrapper } from '@va/util/components';
import classNames from 'classnames';
import {
  SenderEmailCreationContextParams,
  SenderEmailCreationContextProvider,
  SenderEmailCreationStep,
  useSenderEmailCreationContext,
} from './senderEmailCreationContext';
import { AddSenderNameStep } from './steps/AddSenderNameStep';
import { VerifyDnsStep } from './steps/VerifyDnsStep';

export const SenderEmailChangeModal = ({
  isOpen,
  closeModal,
  email,
  onSuccess,
  customSenderEmailId,
}: {
  isOpen: boolean;
} & SenderEmailCreationContextParams) => {
  const translate = useTranslate();

  return (
    <ModalWrapper closeModal={closeModal} isModalOpen={isOpen}>
      <ModalHeader
        title={translate('customSenderEmail.confirmChange.title')}
        onClose={closeModal}
        className={'overflow-hidden'}
        titleClassName={'truncate'}
      />
      <SenderEmailCreationContextProvider
        customSenderEmailId={customSenderEmailId}
        onSuccess={onSuccess}
        closeModal={closeModal}
        email={email}
      >
        <ModalContent />
      </SenderEmailCreationContextProvider>
    </ModalWrapper>
  );
};

const ModalContent = () => {
  const { activeStep } = useSenderEmailCreationContext();

  return (
    <div className={classNames('max-w-[46.875rem] w-screen')}>
      <GrayGradientDivider />
      {activeStep === SenderEmailCreationStep.verifyDNS && <VerifyDnsStep />}
      {activeStep === SenderEmailCreationStep.addSenderName && <AddSenderNameStep />}
      <GrayGradientDivider className='h-[0.125rem]' />
    </div>
  );
};
